'use client';

import 'swiper/css';
import 'swiper/css/a11y';
import { A11y, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import cn from '@/lib/cn';
import SanityImage from './SanityImage';

export default function FeatureSlider({
  className = undefined,
  entries,
}: {
  /** Additional CSS class(es) for the icon */
  className?: string;
  /** Entries of the slider */
  entries: {
    _key: string;
    image: SanityImageWithAlt;
    text: string;
    title: string;
  }[];
}) {
  return (
    <Swiper
      className={cn('!overflow-visible overscroll-contain', className)}
      grabCursor
      modules={[A11y, Mousewheel]}
      mousewheel={{
        forceToAxis: true,
      }}
      slidesPerView="auto"
      spaceBetween={8}
    >
      {entries.map((entry) => (
        <SwiperSlide
          key={entry._key}
          className="!min-w-[18.75rem]"
          style={{
            width: `calc(${100 / entries.length}% - ${(8 * (entries.length - 1)) / entries.length}px)`,
          }}
        >
          <SanityImage
            className="aspect-[3/4] rounded-lg object-cover"
            image={entry.image}
            sizes="300w"
          />

          <p className="text-md mt-4 font-medium">{entry.title}</p>

          <p className="mt-2 text-sm text-black/70">{entry.text}</p>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
